import { useContext } from 'react';

import { FormContext } from './constants';

const useFormContext = () => useContext(FormContext);

export { FormContext };
export default useFormContext;
